// import { canUseDOM } from 'exenv';

export function authorLoading(resp = {}, store) {
  return {
    type: 'AUTHOR_LOADING',
    author: resp,
    store
  };
}

export function authorLoaded(resp = {}, store) {
  return {
    type: 'AUTHOR_LOADED',
    author: resp.user,
    store
  };
}

export function authorLoadError(error, store) {
  return {
    type: 'AUTHOR_ERROR',
    author: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
